export const applicationStyles = (theme) => ({
  root: {
    height: '100%',
    position: 'relative',
  },
  container: {
    height: '100%',
    alignItems: 'center',
    padding: '40px 20px',
    [theme.breakpoints.down('xs')]: {
      padding: '20px 10px',
    },
  },
  buttons: {
    height: '32px',
    width: '180px',
    fontSize: '14px',
  },
  upload: {
    color: '#63666a',
  },
  gridRow: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    margin: '24px 0 0 0',
  },
  gridRowHeader: {
    backgroundColor: 'rgba(0, 65, 101, 0.1)',
  },
  divider: {
    margin: '12px 0',
  },
  return: {
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    margin: '0 0 15px 0',
    '&:hover': { cursor: 'pointer' },
  },
  dummyButton: {
    position: 'absolute',
    right: 0,
    top: '0.5em',
    width: '20em',
    '& *': {
      visibility: 'hidden',
    },
    '&:hover': {
      '& *': {
        visibility: 'visible',
      },
    },
  },
})
